import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { Link, useMatch } from "../../../vendor/router-ROUTER_TARGET";
// import { MenuItem } from "react-contextmenu";
import { Root, Trigger, Content, Item, Portal } from "@radix-ui/react-context-menu";

import More from '../common/More';
import ModalCTA from '../modal/ModalCTA';
import ModalButton from '../modal/ModalButton';
import IconRemove from './svg/IconRemove';
import IconSaveAs from './svg/IconSaveAs';
import IconHistory from './svg/IconHistory';

import { connect } from "react-redux";
import { setModal, addToast, /*setContextMenu,*/ clearHistoryTracks } from "../../../actions/index";
import useTracksToPlaylist from '../../../hooks/useTracksToPlaylist';
import { getContextMenuPortalContainer, rightClickContextMenu } from "../../../utils/zoomMenu";

// V2
function ConnectedRecentlyPlayed({
  historyTracks, setModal, /*setContextMenu,*/ isConnected, enableActions, storeAuth, storePlaylists,
  clearHistoryTracks, storeRoute,
  addToast
}) {
  let match = useMatch({ path: '/history', end: true });
  const setHistory = () => {
    storeRoute.goTo('/history');
  }
  const tracks = historyTracks.slice(0, Config.RECENT_TRACKS_LIMIT);

  const { addToPlaylist } = useTracksToPlaylist(tracks);

  const showClearModal = () => {
    const clear = () => {
      clearHistoryTracks();
      addToast({ content: <span>Recently played cleared.</span>, typeClass: 'neutral', iconStyle: { padding: 16, marginRight: 16 } });
    }

    setModal({ //V2
      content: (
        <ModalCTA
          title={`Clear recent`}
          description={`Are you sure you want to clear recently played?`}
          styleContainer={{marginTop: `-60%`, marginLeft: `-10%`}}
          styleBody={{gap: 32}}
          classModal={`bottom-reduce`}
        >
          <ModalButton label={`Clear`} className={`red-white`} onClick={clear} keyPress={true} />
          <ModalButton label={`Cancel`} className={`cancel`}  />
        </ModalCTA>
      )
    })
  }

  /*
  // V1 - react-contextmenu
  const setActionsContextMenu = () => {
    setContextMenu([
      <MenuItem key={`dPlaylist`} onClick={addToPlaylist} data={{ action: 'Updated' }}>
        <div className={'flexRow block-contextmenu-item all-hover'}>
          <IconSaveAs />
          {`Save playlist`}
        </div>
      </MenuItem>,
      <MenuItem key={`cHistoryTracks`} onClick={showClearModal} data={{ action: 'Clear' }}>
        <div className={'flexRow block-contextmenu-item'}>
          <IconRemove />
          {`Clear recent`}
        </div>
      </MenuItem>
    ], {className: 'dynamic-menu-playlist-menu'});
  }
  */
  // const onRightClick = (e) => {
  //   const el = document.getElementById(`more-ref-RP`);
  //   (el) && el.click();
  // }

  const showContextMenu = (e) => {
    // setActionsContextMenu();  // V1 - react-contextmenu
    rightClickContextMenu(e); // V2 - Right Click Simulation
  }

  //V2 - @radix-ui/react-context-menu
  const ContextMenuContent = () => (
    <Portal container={getContextMenuPortalContainer()}>
      <Content className={'dynamic-menu-v2'}>
        <Item onSelect={addToPlaylist}>
          <div className={'flexRow block-contextmenu-item-v2 all-hover'}>
            <IconSaveAs />
            {`Save playlist`}
          </div>
        </Item>
        <Item onSelect={showClearModal}>
          <div className={'flexRow block-contextmenu-item-v2'}>
            <IconRemove />
            {`Clear recent`}
          </div>
        </Item>
      </Content>
    </Portal>
  )

  //<div className={`menu-left-container ${match && `selected`} allow-menu`} onContextMenu={onRightClick} >
  return (
    <Root modal={false}>
      <Trigger>
        <div className={`menu-left-container ${match && `selected`} allow-menu`} >
          <Link id={`link-ref-rp`} onClick={setHistory} style={{textDecoration: `none`}} to={'/history'}>
            <div id={`ref-rp`} className={`flexRow align top-menu-container ${match && `selected`} `}  >
              <IconHistory />
              <span className={`type-regular fz14`}>Recently played</span>
            </div>
          </Link>
          { tracks.length > 0 ? <More id={`more-ref-RP`} size={24} className={`playlist-more top-menu-section`} onClick={showContextMenu} /> : null }
        </div>
      </Trigger>
      <ContextMenuContent />
    </Root>
  )
}

ConnectedRecentlyPlayed.propTypes = {
  style: PropTypes.object
}

const RecentlyPlayed = connect(
  state => ({
    isConnected: state.isConnected,
    enableActions: (state.isConnected),
    historyTracks: state.historyTracks,
    storeRoute: state.storeRoute,
    storeAuth: state.storeAuth,
    storePlaylists: state.storePlaylists
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    addToast: content => dispatch(addToast(content)),
    // setContextMenu: (items, options) => dispatch(setContextMenu(items, options)),
    clearHistoryTracks: () => dispatch(clearHistoryTracks()),
  })
)(ConnectedRecentlyPlayed);

export default RecentlyPlayed;
